import { render, staticRenderFns } from "./PermisoUsuario.vue?vue&type=template&id=5c4c93cb&"
import script from "./PermisoUsuario.vue?vue&type=script&lang=js&"
export * from "./PermisoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports